import storage from '@/utils/storage';

function logout() {
  storage.clearToken();

  window.location.pathname = '/login';
}

export { logout };
